//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import HelpIcon from '@components/atoms/help-icon/HelpIcon';

export const NonBusinessTooltip = () => {
  return (
    <StyledHelpIcon
      helpText={
        'This user has a Personal Account. You will only be able to view mentioned and tagged content, and will see limited metrics for this user.'
      }
    />
  );
};

const StyledHelpIcon = styled(HelpIcon)(
  ({ theme }) => `
  svg {
    color: ${theme.colors.red8};
  };
`,
);
